import { Component, Input } from '@angular/core';
import {
  WarningArrayItemDeletionComponent,
} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventManager } from '../../../../../../core/managers/event.manager';
import { CalculationEventEnum } from '../../../../../../core/enums/calculation-event.enum';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  SalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import {
  CorporateIncomeTaxConnectedCorporationOptions,
} from '../../../../../../../../../../../common/src/options/calculations/income-tax/corporate/common/corporate-income-tax-connected-corporation.options';


@Component({
  selector: 'app-salary-dividend-corporate-tax-connected-corporations-form',
  templateUrl: './salary-dividend-corporate-tax-connected-corporations-form.component.html',
  styleUrls: ['./salary-dividend-corporate-tax-connected-corporations-form.component.scss'],
  standalone: false,
})
export class SalaryDividendCorporateTaxConnectedCorporationsFormComponent {

  @Input()
  connectedCorporations: AdvancedFormArray<CorporateIncomeTaxConnectedCorporationOptions>;
  @Input()
  form: AdvancedForm<SalaryDividendOptions>;

  constructor(public modalService: NgbModal, private readonly eventManager: EventManager) {

  }

  async removeChildren(connectedCorporationIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent);
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cette société rattachée';
    modal.closed.subscribe(async result => {
      if (result === true) {
        // Here we delete only in the form, not syncing the change to the server or else deleting could cause bad data to be sync.
        this.connectedCorporations.delete(connectedCorporationIndexToRemove);
        // Re-validate so the error list no longer references the removed corporation's index.
        this.eventManager.publishEvent(CalculationEventEnum.FormArrayItemDeleted);

        return;
      }
    });

    return;
  }

  addConnectedCorporation() {
    this.connectedCorporations.appendNew();
  }
}
